var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 7.0573L1.6763 11.381C1.38434 11.673 0.910965 11.673 0.618999 11.381C0.327033 11.0891 0.327033 10.6157 0.618999 10.3237L4.94272 6L0.618999 1.67628C0.327033 1.38431 0.327033 0.910942 0.618999 0.618976C0.910965 0.32701 1.38434 0.32701 1.6763 0.618976L6.00002 4.9427L10.3237 0.618976C10.6157 0.32701 11.0891 0.32701 11.3811 0.618976C11.673 0.910942 11.673 1.38431 11.3811 1.67628L7.05733 6L11.3811 10.3237C11.673 10.6157 11.673 11.0891 11.3811 11.381C11.0891 11.673 10.6157 11.673 10.3237 11.381L6.00002 7.0573Z",
    fill: "#7E868E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d01b39ca5b1a31c95774e734c114fa39.svg";
export { ForwardRef as ReactComponent };